var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "view-all-tenancies-component" } },
    [
      _c("sticky", [
        _c("div", { staticClass: "clearfix header-panel" }, [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "notice-header" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$i18n.t("tenancy.viewAll.title")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-btns" },
            [
              _vm.canCreateTenancy
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      on: {
                        click: function ($event) {
                          return _vm.createNewTenancyRecord()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("company.tenancyRecord.createTenancyRecord")
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "HKLButton",
                { attrs: { color: "orange" }, on: { click: _vm.exportExcel } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.exportSearchResults")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { type: "button" },
                  on: {
                    click: function () {
                      return _vm.resetFilters()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.resetFilter")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { id: "query-btn", type: "button" },
                  on: {
                    click: function () {
                      return _vm.search()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.search")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tenancy-view-all-table" },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "inline",
                "vertical-align": "middle",
                "margin-left": "15px",
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("total")) + ": " + _vm._s(_vm.displayListLength)
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("CommonTable", {
            ref: "tenancy-record-table",
            attrs: {
              tableId: "tenancy-record-table",
              renderHeaderList: _vm.itemHeaders,
              tableContentLists: _vm.sortedItems,
              needSearch: true,
              defaultOrder: true,
              defaultOrderKey: _vm.defaultOrderKey,
              yScrollAuto: true,
              getDisplayListLength: _vm.getDisplayListLength,
              getConditions: _vm.getConditions,
              enterEvent: _vm.search,
              interactionFunc: _vm.interactionFunc,
              orderMethods: _vm.orderMethods,
              getTableOrder: _vm.getTableOrder,
              orderByDateKeys: ["goExpiredDate"],
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "HKLRemindModal",
        { ref: "remindEmptyModal" },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("hint.emptySearch")) + "\n    "),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }